import { Route } from 'react-router-dom';
import { ExperienceEventsRoute } from './events/route';
import { ExperienceReservationsRoute } from './reservations/route';
import { ExperienceSessionsRoute } from './sessions/route';
import { ExperienceActionsRoute } from './actions/route';

export const ExperiencesRoute = (
  <Route path="experience">
    {ExperienceEventsRoute}
    {ExperienceReservationsRoute}
    {ExperienceSessionsRoute}
    {ExperienceActionsRoute}
  </Route>
);
